import { useLocation } from 'react-router-dom';

import { PostCheckParams } from 'src/near-me-check/hooks/use-post-check-query';

const useSearchParams = (): PostCheckParams | null => {
    const location = useLocation();
    const search = new URLSearchParams(location?.search);

    const name = search.get('name');
    const streetAndNumber = search.get('streetAndNumber');
    const zipCode = search.get('zipCode');
    const city = search.get('city');
    const country = search.get('country');
    const categoryId = search.get('categoryId');
    const email = search.get('email') || undefined;
    const phoneNumber = search.get('phoneNumber') || undefined;

    if (name && streetAndNumber && (zipCode || city) && country && categoryId) {
        return {
            name,
            streetAndNumber,
            country,
            categoryId,
            email,
            phoneNumber,
            ...(zipCode
                ? { zipCode, city: undefined }
                : { zipCode: undefined, city: city as string }),
        };
    }

    return null;
};

export { useSearchParams };
